import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { Box } from '@radix-ui/themes';
import 'swiper/css';
import 'swiper/css/pagination';

import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';

export const BannerSlider = ({ banners }) => {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';
  return (
    <Box className="banner-slider">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop
        slidesPerView={1}
      >
        {banners.map(banner => (
          <SwiperSlide key={banner.id}>
            <Link to={banner.to} title={banner.title} className="slim-banner">
              <img src={banner.src} alt={banner.alt} />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default BannerSlider;
